/* eslint-disable no-param-reassign */

import React, { useState, useEffect } from 'react';
import { PseudoStates, PageTitle } from '@cordata/buffet';
import { useParams } from 'react-router-dom';

import DiagnosisForm from '~/components/Diagnosis/Form';
import { store } from '~/utils/diagnosis';

const DiagnosisDetails = () => {
  const params = useParams();
  const [data, setData] = useState([]);
  const [status, setStatus] = useState('loading');

  useEffect(() => {
    store.fetchOne(params.diagnosis_id)
      .then(r => {
        setData(r);
        setStatus('success');
      })
      .catch(e => {
        console.error('e:', e);
        setStatus('error');
      });
  }, []);

  return status === 'success' ? (
    <>
      <PageTitle>Edit Diagnosis</PageTitle>

      <DiagnosisForm data={data} />
    </>
  ) : (
    <PseudoStates isLoading={status === 'loading'} error={status === 'error'} />
  );
};

export default DiagnosisDetails;
